.care_site_multi_select {
  padding: 21px 0px 21px 0px;
  position: relative;

  .wrapper_container {
    border-radius: 48px;
    box-shadow: var(--ion-box-shadow);

    .item {
      --padding-start: 21px;
      --padding-end: 4px;
      --min-height: 48px;
      --background: var(--ion-gradient-secondary);
      --background-hover: #a3b6d3;
      --background-activated: #a3b6d3;
      --ripple-color: var(--ion-color-dark-ripple);

      .value {
        margin: 0px 0px 0px 4px;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--ion-color-text-secondary);
      }

      .icon {
        height: 14px;
        width: 14px;
        color: #abb8cd;
      }
    }

    .dropdown {
      max-height: 200px;
      background: var(--ion-gradient-secondary);
      border-radius: 0px 0px 8px 8px;
      box-shadow: var(--ion-box-shadow);

      .dropdown_item {
        --background: var(--ion-gradient-secondary);
        --background-hover: #a3b6d3;
        --background-activated: #a3b6d3;
        --ripple-color: var(--ion-color-dark-ripple);
        --padding-start: 12px;
        --min-height: 40px;
        color: var(--ion-color-text-secondary);
        font-size: 14px;
      }
    }
  }
}
